import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { Appointment } from '../../../modules/appointment/appointment.types'
import { getCurrentLocale } from '../../i18n/i18n.utils'

export enum AppointmentOption {
  NOW = 'NOW',
  LATER = 'LATER',
  CHANGE = 'CHANGE'
}

@Component({
  selector: 'drr-appointment-options-card',
  templateUrl: './appointment-options-card.component.html',
  styleUrls: ['./appointment-options-card.component.scss']
})
export class AppointmentOptionsCardComponent implements OnInit, OnChanges {
  @Input() appointmentSelected: Appointment | null = null

  @Output() onSelected = new EventEmitter<AppointmentOption>()

  AppointmentOption = AppointmentOption

  selectedOption: AppointmentOption

  ngOnInit(): void {
    this.updateSelectedOption(this.appointmentSelected)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.appointmentSelected) {
      this.updateSelectedOption(changes.appointmentSelected.currentValue)
    }
  }

  updateSelectedOption(appointment: Appointment) {
    this.selectedOption = appointment ? AppointmentOption.LATER : AppointmentOption.NOW
  }

  get formattedAppointmentTime(): string {
    const startTime = this.appointmentSelected.slot.startTime
    const endTime = this.appointmentSelected.slot.endTime

    const locale = getCurrentLocale().locale
    const dayName = startTime.toLocaleDateString(locale, { weekday: 'short' })
    const day = startTime.getDate()
    const month = startTime.toLocaleDateString(locale, { month: 'short' })
    const startTimeFormatted = startTime.toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })
    const endTimeFormatted = endTime.toLocaleTimeString(locale, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })

    const timeRangeSeparator = $localize`to`
    return `${dayName} ${day} ${month} ${startTimeFormatted} ${timeRangeSeparator} ${endTimeFormatted}`
  }

  handleRadioChange(event: any): void {
    const selectedValue = event.detail.value as AppointmentOption
    this.selectOption(selectedValue)
  }

  selectOption(option: AppointmentOption): void {
    this.selectedOption = option
    this.onSelected.emit(option)
  }

  handleChangeSchedule(): void {
    this.onSelected.emit(AppointmentOption.CHANGE)
  }
}
